import $ from 'jquery';

function NaviCtrl() {
	this.$win      = $(window);
	this.$htmlBody = $('html, body');
	this.$body     = $('body');
  this.$target = $('.header-site-navi');
  this.$classTarget = $('.header-site-navi, .sp-nav-toggle');
	this.$btnOpen  = $('.sp-nav-toggle');
	this.$btnClose = $('#naviClose');
  this.$content = $('#main');
  this.activeClass = 'toggle-active';

	this.scrollState = 0;

	this.open  = this.open.bind(this);
	this.close = this.close.bind(this);

	this.init();
}

NaviCtrl.prototype.init = function() {
	this.$btnOpen.on('click', this.open);
	this.$btnClose.on('click', this.close);
	this.$target.find('a').on('click', this.close);
}

NaviCtrl.prototype.open = function() {
	if (! this.$target.hasClass(this.activeClass)) {
		let scrollTop = this.$win.scrollTop();
		scrollCache = scrollTop;
		this.scrollState = scrollTop;
		this.$htmlBody.addClass(this.activeClass);
		this.$classTarget.addClass(this.activeClass);
		this.$content.css('transform', `translateY(-${scrollTop}px)`);
	} else {
		this.$htmlBody.removeClass(this.activeClass);
		this.$classTarget.removeClass(this.activeClass);

		this.$win.scrollTop(this.scrollState);
		this.$content.css('transform', 'translateY(0px)');
	}
}

NaviCtrl.prototype.close = function() {
	this.$htmlBody.removeClass(this.activeClass);
	this.$classTarget.removeClass(this.activeClass);

	this.$win.scrollTop(this.scrollState);
	this.$content.css('transform', 'translateY(0px)');
}

export default NaviCtrl;